module.exports = __webpack_public_path__ + "img/huanJing3.7100c07b.jpg";